import { Injectable, Inject } from '@angular/core';
import { CognitoService } from '@odin/odin-authentication';
import { NotificationHttpService } from './notification-http.service';
import { NotificationDataService } from './notification-data.service';
import { take, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotificationInitializerService {
  private initialized = false;

  constructor(
    private cognitoService: CognitoService,
    private notificationHttpService: NotificationHttpService,
    private notificationDataService: NotificationDataService
  ) {
    // Listen for login changes
    this.cognitoService.loginChanged.subscribe((loggedIn: boolean) => {
      if (loggedIn) {
         this.initNotifications();
      }
    });

    // If already logged in on app start
    if (this.cognitoService.userLoggedIn()) {
        this.initNotifications();
    }
  }

  private initNotifications(): void {
    if (this.initialized) return;
    this.initialized = true;
      this.notificationDataService.connect();
      this.notificationHttpService.getNotifications()
      .pipe(take(1))
      .subscribe(notifications => {
        this.notificationDataService.setNotifications(notifications.map(n => ({ ...n, read: true })));
      });

  }
}
